// import external dependencies
import $ from 'jquery';
// Import just what we need
// https://getbootstrap.com/docs/5.0/customize/optimize/

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

// MODERNIZR for detect webp images browser support
// https://modernizr.com/download?webp-setclasses&q=webp
if(typeof Modernizr == 'object'){
    Modernizr.on('webp', function (result) {
        if (result) {
            // supported
        } else {
            // not-supported
        }
    });
}

/******************* LIB IMPORTS **************************/
// add more libs here
import "./custom-libs/fontawesome.js";
import "./custom-libs/slick.js";
// import mapboxgl from 'mapbox-gl';


/******************* IMPORT BA START **************************/
import 'slick-carousel';
// import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import {faPhone, faMapPin, faCalendarMinus, faSpinner, faEnvelope, faPhoneAlt, faAngleDoubleRight, faAngleDoubleLeft, faTicketAlt, faTag} from "@fortawesome/free-solid-svg-icons";
// import {faCircleXmark, faFolderOpen, faNewspaper} from '@fortawesome/free-regular-svg-icons';
// import { faTwitter, faFacebook, faFacebookF, faYoutube, faInstagram, faLinkedinIn} from '@fortawesome/free-brands-svg-icons';
// library.add(faTwitter, faFacebook, faFacebookF, faYoutube, faInstagram, faLinkedinIn, faPhone, faEnvelope, faMapPin, faCalendarMinus, faSpinner, faCircleXmark, faPhoneAlt, faAngleDoubleRight, faAngleDoubleLeft, faNewspaper, faFolderOpen, faTicketAlt, faTag);
// dom.watch();

/******************* ROBERTO is HERE **************************/
// add theme scripts here
import "./roberto/lazy.js";
import "./roberto/main.js";
